import { inject, Injectable, Injector } from '@angular/core';

import { LanguageStrategy } from '@generator-strategies/language-strategy';

import { LanguageService } from '@core/services/language.service';

@Injectable({ providedIn: 'root' })
export class AppLanguageStrategy extends LanguageStrategy {
  private readonly injector = inject(Injector);
  private languageService?: LanguageService;

  override currentLanguage(): string {
    if (!this.languageService) {
      this.languageService = this.injector.get(LanguageService);
    }
    return this.languageService.currentLanguage() || 'en';
  }
}
